// extracted by mini-css-extract-plugin
module.exports = {"page":"styles-module--page--1qGtA","scrollRef":"styles-module--scrollRef--1V9ju"};